export const LOCALE_TO_VALUE: Record<string, string> = {
  "en-US": "US",
  "zh-CN": "CN",
};

export const LOCALE_TO_DISPLAY_VALUE: Record<string, string> = {
  "en-US": "English",
  "zh-CN": "简体中文",
};

export const COUNTRIES_TO_DOMAINS: Record<string, string> = {
  US: "https://www.flexport.com",
  CN: "https://cn.flexport.com",
};
